import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mapTo } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { CreateInvoiceFormRequest } from '@feature/invoice-upload/models/create-invoice-form-request';
import { MojoFormsDesign } from '@feature/invoice-upload/models/mojo-forms-design';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class MojoFormsInvoiceService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService) {
  }

  getInvoiceFormsDesigns(): Observable<MojoFormsDesign[]> {
    const url = this.urlBuilder.getMojoApiUrl('eas/CreditorInvoiceFormDesigns');
    return this.http.get<MojoFormsDesign[]>(url);
  }

  uploadInvoice(createFormRequest: CreateInvoiceFormRequest, invoice: File, additionalDocs: File[], product: string): Observable<boolean> {

    const docs = additionalDocs || [];

    const url = this.urlBuilder.getMojoApiUrl('eas/invoiceupload');

    const body = new FormData();

    body.append('CreditorUri', `${createFormRequest.CreditorUri}`);
    body.append('BillingAddress', createFormRequest.BillingAddress || '');
    body.append('DocumentDate', moment(createFormRequest.DocumentDate).utc(true).format());
    body.append('DocumentReference', createFormRequest.DocumentReference);
    body.append('DocumentTypeCode', createFormRequest.DocumentTypeCode);
    body.append('GrossAmount', `${createFormRequest.GrossAmount}`);
    body.append('NetAmount', `${createFormRequest.NetAmount}`);
    body.append('FormDesignId', `${createFormRequest.FormDesignId}`);
    body.append('ServicesRendered', createFormRequest.ServicesRendered || '');
    body.append('VatAmount', `${createFormRequest.VatAmount}`);
    body.append('VatRateCode', createFormRequest.VatRateCode);
    body.append('PurchaseOrderId', createFormRequest.PurchaseOrderId);
    body.append('ContractId', createFormRequest.ContractId);
    body.append('FromDate', moment(createFormRequest.FromDate).utc(true).format());
    body.append('ToDate', moment(createFormRequest.ToDate).utc(true).format());
    body.append('Product', product);

    for (let i = 0; i < docs.length; i++) {
      body.append('AdditionalDocs', additionalDocs[i]);
    }

    const ieHack: any = invoice;
    ieHack.FileName= invoice.name;
    body.append('InvoicePdf', invoice);
    return this.http.post(url, body).pipe(mapTo(true as boolean));

  }
}
